import type { GuaranteedMode } from '@nadoutong/contracts';
import { Select, StatusLamp } from '../../ui/index.ts';
import { isMode, MODE_VALUES, modeLamp } from './modes.ts';

/**
 * One mechanism's off / shadow / act control: a compact select sized to
 * its two-character values, each option carrying the mode lamp.
 */
export function ModeControl({
  value,
  labelOf,
  disabled,
  ariaLabel,
  testId,
  onChange,
}: {
  readonly value: GuaranteedMode;
  readonly labelOf: (mode: GuaranteedMode) => string;
  readonly disabled: boolean;
  readonly ariaLabel: string;
  readonly testId: string;
  readonly onChange: (mode: GuaranteedMode) => void;
}): JSX.Element {
  return (
    <span className="block w-[6.25rem]">
      <Select
        compact
        value={value}
        disabled={disabled}
        onValueChange={(next) => {
          if (isMode(next) && next !== value) onChange(next);
        }}
        options={MODE_VALUES.map((mode) => ({
          value: mode,
          label: (
            <span className="inline-flex items-center gap-1.5">
              <StatusLamp tone={modeLamp(mode)} size="sm" />
              {labelOf(mode)}
            </span>
          ),
        }))}
        ariaLabel={ariaLabel}
        testId={testId}
      />
    </span>
  );
}
